<template>
      <zkContent leftStyle="width:40%" rightStyle="width:60%"  :leftTitle="this.$t('attendanceCode.laborCodesType')" :rightTitle="this.$t('attendanceCode.laborCodeDeatils')" style="height:100%">
        <div slot="left">
          <workCodeType ref="workCodeType" @SelectType="SelectTypeFn"></workCodeType>
        </div>
        <div slot="right">
          <workCode :selectAttCode="select"></workCode>
        </div>
      </zkContent>
</template>

<script>
import workCode from './attendanceCode/workCode'
import workCodeType from './attendanceCode/workCodeType'
export default {
  data () {
    return {
      select: null
    }
  },
  mounted () {

  },
  methods: {
    SelectTypeFn (row) {
      this.select = row
    }
  },
  components: {
    workCode,
    workCodeType
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/attendanceCode.vue